export default __webpack_public_path__ + "static/media/upload1.cad7cc67.svg";